export const LISTEN_TO_SELECTED_USER_PROFILE = 'LISTEN_TO_SELECTED_USER_PROFILE';
export const LISTEN_TO_CURRENT_USER_PROFILE = 'LISTEN_TO_CURRENT_USER_PROFILE';
export const LISTEN_TO_USER_ORDERS = 'LISTEN_TO_USER_ORDERS';
export const LISTEN_TO_USER_PHOTOS = 'LISTEN_TO_USER_PHOTOS';
export const LISTEN_TO_USER_NOTIFICATIONS = 'LISTEN_TO_USER_NOTIFICATIONS';
export const LISTEN_TO_USER_UNREAD_NOTIFICATIONS_COUNT =
  'LISTEN_TO_USER_UNREAD_NOTIFICATIONS_COUNT';
export const LISTEN_TO_CADDYS_PROFILES = 'LISTEN_TO_CADDYS_PROFILES';
